import {
  CardActivationScriptName,
  GetCardActivationInfoResponse,
} from "../../../lib/api/models";
import styles from "./CardActivationScript.module.css";
import ConversationScript from "../../common/ConversationScript";
import { getCardActivationScriptDetails } from "../cardActivationScripts";

const strings = {
  script: "Script",
};

type Props = {
  scriptName: CardActivationScriptName | undefined;
  cardActivationInfo: GetCardActivationInfoResponse;
};

export default function CardActivationScript({
  scriptName,
  cardActivationInfo,
}: Props) {
  const scriptDetails = getCardActivationScriptDetails(
    scriptName,
    cardActivationInfo.creditLimitCents,
  );

  return (
    <>
      <div className={styles.scriptHeader}>{strings.script}</div>
      {scriptDetails && (
        <ConversationScript
          className={styles.scriptContainer}
          scripts={scriptDetails.script}
          scriptName={scriptDetails.name}
        />
      )}
    </>
  );
}
